/*
 * @Author: TinaHuang0183
 * @Date: 2022-08-05 11:49:31
 * @LastEditors: TinaHuang0183 Tina.Huang@splashtop.com
 * @LastEditTime: 2022-08-26 15:13:58
 * @FilePath: /notion-widgets-site/src/plugins/crypto.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import { enc, mode, AES, pad } from "crypto-js";

// 加密密钥（长度必须是 16 的整数倍，此处为 32 位）
const secretKey = "httishere9607281";

/**
 * ASE加密
 * @description 使用加密秘钥，对 需要加密的参数 进行加密
 * @param {string} word - 需要加密的参数
 * @param {string} key - 加密密钥（长度必须是 16 的整数倍）
 * @param {string} offset - 偏移量
 */
const aseEncryptParams = (word, key = secretKey) => {
  key = enc.Utf8.parse(key); // 将字符串的转为WordArray类型
  let mydata = enc.Utf8.parse(word);
  let udata = AES.encrypt(mydata, key, {
    mode: mode.ECB, // 加密模式，ECB模式
    padding: pad.Pkcs7, // 填充方式
  });
  let encrypted = udata.toString(); //  返回的是base64的密文,是字符串类型
  return encrypted;
};

/**
 * ASE解密
 * @description 使用加密秘钥，对 需要解密的参数 进行解密
 * @param {string} encryptedWord - 需要解密的参数
 * @param {string} key - 加密密钥（长度必须是 16 的整数倍）
 * @param {string} offset - 偏移量
 */
export function aesDecryptParams(encryptedWord, key = secretKey) {
  key = enc.Utf8.parse(key);
  let udata = AES.decrypt(encryptedWord, key, {
    mode: mode.ECB,
    padding: pad.Pkcs7,
  });
  let decrypted = udata.toString(enc.Utf8); // 返回的是加密之前的原始数据,是字符串类型
  return decrypted;
}

export default {
  aseEncryptParams,
  aesDecryptParams,
};
